import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "./dialog.helper";

export class DefaultDialogs {
    private __env: any;
    private dialog: DialogUtils;

    constructor(__env: any, DialogUtils: DialogUtils) {
        this.__env = __env;
        this.dialog = DialogUtils;
    }

    contactSupport(title: string, reason: string, ev: any): void {
        let dialog = this.dialog
            .alert()
            .title(title)
            .textContent(
                `Please contact ${this.__env.support_email} or ${this.__env.sales_email} to discuss ${reason}.`
            )
            .targetEvent(ev)
            .ok("OK");
        this.dialog.showPreConfiguredDialog(dialog);
    }
}

angular.module("vcHelper", []).service("DefaultDialogs", DefaultDialogs);
